import { Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';

import { AdminQuestionnaire } from '@/types/components';

type Questionnaire = AdminQuestionnaire;

type Props = {
  isOpen: boolean;
  questionnaire?: Questionnaire | null;
  onClose: () => void;
  onSave: (
    questionnaire:
      | Questionnaire
      | Omit<AdminQuestionnaire, 'id' | 'createdAt' | 'updatedAt'>,
  ) => void;
  mode: 'add' | 'edit';
};

export default function QuestionnaireModal({
  isOpen,
  questionnaire,
  onClose,
  onSave,
  mode,
}: Props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (mode === 'edit' && questionnaire) {
        form.setFieldsValue({
          currentQuestionId: questionnaire.currentQuestionId,
          userId: questionnaire.user?.id,
          userName: questionnaire.user?.name,
          userEmail: questionnaire.user?.email,
        });
      } else if (mode === 'add') {
        form.resetFields();
        form.setFieldsValue({
          currentQuestionId: '',
        });
      }
    }
  }, [questionnaire, mode, isOpen, form]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      const formattedData = {
        currentQuestionId: values.currentQuestionId || '',
        user: {
          id: values.userId,
          name: values.userName || '',
          email: values.userEmail,
        },
        industry: undefined,
      };

      if (mode === 'edit' && questionnaire) {
        onSave({
          ...questionnaire,
          ...formattedData,
        });
      } else {
        onSave(formattedData);
      }
      onClose();
    } catch (error) {
      console.error('Form validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={mode === 'edit' ? '編輯問卷' : '新增問卷'}
      open={isOpen}
      onOk={handleSave}
      onCancel={handleCancel}
      okText="儲存"
      cancelText="取消"
      width={600}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <div>
          <div>
            <h4>用戶資訊</h4>

            <Form.Item
              label="用戶ID"
              name="userId"
              rules={[{ required: true, message: '請輸入用戶ID' }]}
            >
              <Input placeholder="請輸入用戶ID" />
            </Form.Item>

            <Form.Item label="用戶姓名" name="userName">
              <Input placeholder="請輸入用戶姓名" />
            </Form.Item>

            <Form.Item
              label="用戶電郵"
              name="userEmail"
              rules={[
                { required: true, message: '請輸入用戶電郵' },
                { type: 'email', message: '請輸入有效的電郵地址' },
              ]}
            >
              <Input placeholder="請輸入用戶電郵" />
            </Form.Item>
          </div>

          <div>
            <h4>問卷進度</h4>

            <Form.Item label="當前問題ID" name="currentQuestionId">
              <Input placeholder="請輸入當前問題ID" />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
